var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.firstRun)?_c('pm-welcome-screen',{attrs:{"steps":_vm.welcomeSteps}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }